import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { UsersListState, UsersObject } from '../types'
import { usersFullDataList, deleteUserAction } from './helpers'

const noUsersListConfig = {
  usersFullList: [],
  isInitalized: false,
  isLoading: true,
  hasError: false,
}

interface SetUsersListPayload {
  usersFullList?: []
}

const initialState: UsersListState = { ...noUsersListConfig }

export const usersListSlice = createSlice({
  name: 'UsersList',
  initialState,
  reducers: {
    fetchUsersList: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setUserList: (state, action: PayloadAction<SetUsersListPayload>) => {
      state.usersFullList = action.payload.usersFullList
      state.isLoading = false
      state.isInitalized = true
      state.hasError = false
    },
    deleteUserList: (state, action: PayloadAction<SetUsersListPayload>) => {
      state.usersFullList = []
      state.isInitalized = false
      state.isLoading = false
      state.hasError = false
    },
    fetchUsersListFailed: (state) => {
      state.usersFullList = []
      state.isInitalized = false
      state.isLoading = false
      state.hasError = true
    },
  },
})

export const fetchUsersListData = (accessToken: string) => async (dispatch) => {
  try {
    dispatch(fetchUsersList())
    const usersFullList = await usersFullDataList(accessToken)
    dispatch(
      setUserList({
        usersFullList,
      }),
    )
  } catch (error) {
    message.error('User list not found - redirecting')
    dispatch(fetchUsersListFailed())
    localStorage.clear()
    sessionStorage.clear()
	window.location.href='/login'
  }
}

export const deleteUserFromList = (_id: string, accessToken: string) => async (dispatch) => {
  try {
    dispatch(fetchUsersList())
    const deletedUser = await deleteUserAction(_id, accessToken)
    if (deletedUser) {
      if (deletedUser?.error) {
        message.error(deletedUser?.error)
      } else if (deletedUser?.message) {
        message.success('User deleted');
        window.location.href = '/list-users';
      }
    }
    const usersFullList = await usersFullDataList(accessToken)
    dispatch(
      setUserList({
        usersFullList,
      }),
    )
  } catch (error) {
    message.error('User list not found - redirecting')
    dispatch(fetchUsersListFailed())
    localStorage.clear()
    sessionStorage.clear()
	window.location.href='/login'
  }
}

// Actions
export const { setUserList, fetchUsersList, fetchUsersListFailed } = usersListSlice.actions

export default usersListSlice.reducer
